import React, { useEffect, useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Notification from "../../elements/notification/Notification";
import { Helmet } from "react-helmet-async";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import ClientCreateForm from "./ClientCreateForm";
import ClientsList from "./ClientsList";
import ClientFilter from "./ClientFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import { useTranslation } from "react-i18next";

import MaterialPagination from "../../styles/materialPagination";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledClientsListWrapper } from "../styledClients";

import { ROLES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";

const ClientsContainer = () => {
  const { t } = useTranslation("clientsPage");
  const [clients, setClients] = useState(null);
  const [fetch, setFetch] = useState(false);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "nickname": checkFilterItem(history, "nickname", null),
    "firstname": checkFilterItem(history, "firstname", null),
    "lastname": checkFilterItem(history, "lastname", null),
    "email": checkFilterItem(history, "email", null),
    "createDate[gte]": checkFilterItem(history, "createDate[gte]", null, true),
    "createDate[lte]": checkFilterItem(history, "createDate[lte]", null, true)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchClients = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/users" + filterUrl + "&roles=" + ROLES.ROLE_USER, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setClients(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchClients();
  }, [filterData, fetch]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledClientsListWrapper>
          <div className="clients-head clients-head_superAdmin">
            <ClientFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
            <ClientCreateForm
              notification={notification}
              setNotification={setNotification}
              setFetch={setFetch}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ClientsList clients={clients} notification={notification} setNotification={setNotification} />
          {totalPageCount > 1  &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledClientsListWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default ClientsContainer;